export const IconAggregate = () => {
  return (
    <svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          "M10.708 0.221191L11.4053 0.918457L7.13965 5.18408L4.51465 2.55908L1.29492 " +
          "5.77881L0.597656 5.08154L4.51465 1.16455L7.13965 3.78955L10.708 0.221191Z"
        }
        fill="currentColor"
      />
    </svg>
  );
};
